import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root",
})
export class StateService {
  public url: any;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  private createHeaders(token: any): HttpHeaders {
    return new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
      authorization: token,
    });
  }

  private createRequest(url: any, params: any, token: any): Observable<any> {
    return this._http
      .post(url, params, { headers: this.createHeaders(token) })
      .pipe(map((res) => res as any));
  }

 

  listByCountry(id: any, token: any) {

     return this.createRequest(
      this.url + `/state/listbycountry/${id}`,
      `authorization=${token}`,
      token
    );
  }
}
